export interface TranscriptEntryLike {
  role: 'user' | 'model';
  text: string;
  timestamp: number;
}

export class TranscriptStore {
  private value: TranscriptEntryLike[] = [];

  getAll(): TranscriptEntryLike[] {
    return [...this.value];
  }

  append(entry: TranscriptEntryLike): TranscriptEntryLike[] {
    this.value = [...this.value, entry];
    return this.getAll();
  }

  replace(next: TranscriptEntryLike[]): TranscriptEntryLike[] {
    this.value = [...next];
    return this.getAll();
  }

  clear(): void {
    this.value = [];
  }
}
